import { LayoutGrid, Table2 } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface CardTableViewToggleProps {
    value: 'card' | 'table'
    onValueChange: (value: 'card' | 'table') => void
    cardLabel?: string
    tableLabel?: string
    iconClassName?: string
    /** When 'table-first', table (list) is on the left and card (board) on the right. Default 'card-first'. */
    order?: 'card-first' | 'table-first'
    /** Icon for the table/list option. Defaults to Table2. */
    tableIcon?: LucideIcon
}

/**
 * Shared toggle for switching between Card and Table view.
 * Used by RunbookTable (object Runbook tab) and RunbookRecoveryTable (recovery runbook page).
 */
export function CardTableViewToggle({
    value,
    onValueChange,
    cardLabel = 'Card',
    tableLabel = 'Table',
    iconClassName = 'h-4 w-4 text-blue-600',
    order = 'card-first',
    tableIcon: TableIcon = Table2,
}: CardTableViewToggleProps) {
    const cardButton = (
        <button
            type="button"
            onClick={() => onValueChange('card')}
            className={`flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
                value === 'card' ? 'bg-background shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
        >
            <LayoutGrid className={iconClassName} />
            {cardLabel}
        </button>
    )
    const tableButton = (
        <button
            type="button"
            onClick={() => onValueChange('table')}
            className={`flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
                value === 'table' ? 'bg-background shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
        >
            <TableIcon className={iconClassName} />
            {tableLabel}
        </button>
    )
    return (
        <div className="flex rounded-lg border p-0.5 bg-muted/30 gap-2">
            {order === 'table-first' ? (
                <>
                    {tableButton}
                    {cardButton}
                </>
            ) : (
                <>
                    {cardButton}
                    {tableButton}
                </>
            )}
        </div>
    )
}
